import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import { Button, Flex, Heading, Icon, Icons, Paragraph } from "@ir/ui";
import { PageHeader } from "@src/presentation/components/Layout/common";
import { usePurchasersData } from "@src/presentation/providers/PurchasersDataProvider";
import HasAnyPermission from "@src/presentation/components/permissions/HasAnyPermission";
import { Permissions } from "@src/domain/permissions";

interface PurchasersHeaderProps {
  onAddPurchaser: () => void;
  isAddPurchaserDisabled?: boolean;
}

export const PurchasersHeader = ({
  onAddPurchaser,
  isAddPurchaserDisabled = false,
}: PurchasersHeaderProps) => {
  const { total, totalActiveCount, loading } = usePurchasersData();

  const subtitle = loading
    ? "Loading purchasers..."
    : `${totalActiveCount} / ${total} Active Purchasers`;

  return (
    <ErrorBoundary>
      <PageHeader>
        <Flex align="center" gap={0.5} justifyContent="space-between">
          <Flex direction="column">
            <Heading level={5} className="text-grey-700 font-bold m-0">
              Purchasers
            </Heading>
            <Paragraph className="text-grey-500 font-regular m-0">
              {subtitle}
            </Paragraph>
          </Flex>
          <HasAnyPermission requiredPermissions={[Permissions.PURCHASERS_ADD]}>
            <Button
              size="small"
              onPress={onAddPurchaser}
              isDisabled={isAddPurchaserDisabled}
            >
              <Icon name={Icons.Plus} slot="start" /> Add Purchaser
            </Button>
          </HasAnyPermission>
        </Flex>
      </PageHeader>
    </ErrorBoundary>
  );
};
